module.exports = __webpack_public_path__ + "media/images/grey_bolt_icon-7ad5b500c417114e3fa0ca4e39410ef4.png";